import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "../board-scene/BoardContainer";
import { TutorialScene } from "./TutorialScene";
import * as Carrom from "carrom-king-engine";

export class TutorialManager {

    constructor() {
        GameVars.reversedBoard = false;
        GameVars.tutorialMode = true;
        GameVars.tutorialStage = TutorialStage.STAGE_0;
        GameVars.turnCompleted = true;
        GameVars.currentTurnPlayerId = GameVars.playerData.id;
        GameVars.paused = false;
        
        let carromConfig = new Carrom.Config();
        carromConfig.friction = GameVars.friction

        GameVars.carromEngine = new Carrom.Engine(carromConfig);

        GameVars.pucks = this.getPucksStartConfiguration();

        GameVars.carromEngine.addEventListener(Carrom.Event.TURN_COMPLETED, this.onTurnCompleted, this);
        GameVars.carromEngine.addEventListener(Carrom.Event.DISK_POCKETED, this.onDiskPocketed, this);
        GameVars.carromEngine.addEventListener(Carrom.Event.CONTACT_DISK_DISK, this.onContactDiskDisk, this);

        setTimeout(function(): void {
            TutorialScene.currentInstance.onTutorialStart();
        }, 500);
    }

    public update(): void {

        if (!GameVars.turnCompleted) {
            GameVars.carromEngine.update();
        }   
    }

    public onNext(): void {

        if (GameVars.tutorialStage === TutorialStage.STAGE_0) {
            GameVars.tutorialStage = TutorialStage.STAGE_1;
            TutorialScene.currentInstance.onTutorialStage1();
        } else {
            GameVars.tutorialMode = false;
            GameManager.enterSplashScene();
        }
    }

    public onSliderDown(): void {

        GameVars.tutorialStage = TutorialStage.STAGE_2;

        TutorialScene.currentInstance.onTutorialStage2();
    }

    public onSliderUp(): void {

        const strikerX = BoardContainer.currentInstance.striker.position.x;

        if (strikerX > GameConstants.STRIKER_TUTORIAL_PX * GameConstants.PHYS_SCALE * .88 && strikerX < GameConstants.STRIKER_TUTORIAL_PX * GameConstants.PHYS_SCALE  * 1.12) {
            GameVars.tutorialStage = TutorialStage.STAGE_3;
            console.log("TutorialOnNextStage");

            TutorialScene.currentInstance.onTutorialStage3();
        } else {
            console.log("WrongPos", strikerX, "--", "Pos should be ", GameConstants.STRIKER_TUTORIAL_PX * GameConstants.PHYS_SCALE * .88, "and", GameConstants.STRIKER_TUTORIAL_PX * GameConstants.PHYS_SCALE * 1.12);

            BoardContainer.currentInstance.onSliderWronglyPlaced();
        }
    }

    public onStrikerDown(): void {

        GameVars.tutorialStage = TutorialStage.STAGE_4;

        TutorialScene.currentInstance.onTutorialStage4();
    }

    public shoot(strikerPosition: Carrom.Vector2D, strikerVelocity: Carrom.Vector2D): void {

        GameVars.turnCompleted = false;

        GameVars.carromEngine.shoot(
            strikerPosition, 
            GameVars.pucks, 
            strikerVelocity, 
            GameVars.gameMode, 
            null, 
            GameVars.queenNeedsToBeCovered
        );
    
        GameVars.queenNeedsToBeCovered = false;

        TutorialScene.currentInstance.onShot();
    }

    private onTurnCompleted(
        strikerPosition: Carrom.Vector2D, 
        pucks: Carrom.Puck [], 
        pocketedPucks: Carrom.Puck [], 
        alternatePlayer: boolean, 
        hasQueenBeenPocketed: boolean, 
        restituteQueen: boolean, 
        skipQueenCovering: boolean,
        score: number,
        hasPlayerWon: boolean,
        hasAdversaryWon: boolean,
        faults: string []
        ): void {

        GameVars.turnCompleted = true;
        GameVars.currentTurnPlayerId = null;

        TutorialScene.currentInstance.onTutorialCompleted();
    }

    private onDiskPocketed(disk: Carrom.Disk): void {
        
        GameVars.tutorialStage = TutorialStage.STAGE_5;
    }

    private onContactDiskDisk(disk1Velocity: Carrom.Vector2D, disk2Velocity: Carrom.Vector2D): void {

        BoardContainer.currentInstance.onContactDiskDisk(disk1Velocity, disk2Velocity);
    }

    private getPucksStartConfiguration(): Carrom.Puck [] {
        
        let pucks: Carrom.Puck [] = [];
      
        let pucksData = [
            {"id": 1, "color": "black", "position": {"xValue": 20000, "yValue": -15000}},
            {"id": 2, "color": "white", "position": {"xValue": 9000, "yValue": 10000}}
        ];
        pucks = [];

        for (let i = 0; i < pucksData.length; i ++) {
            
            const id = pucksData[i].id;
            const color = pucksData[i].color;
            const x = pucksData[i].position.xValue;
            const y = pucksData[i].position.yValue;

            let value: number;

            if (color === Carrom.Color.RED) {
                value = GameVars.carromEngine.pucksValues.red;
            } else if (color === Carrom.Color.WHITE) {
                value = GameVars.carromEngine.pucksValues.white;
            } else {
                value = GameVars.carromEngine.pucksValues.black;
            }

            pucks.push({id: id, color: color, position: new Carrom.Vector2D(x, y), value: value});
        }

        return pucks;
    }
}
